import { RouteObject } from "react-router-dom";

const publicRoutes: RouteObject[] = [
	{ path: "/login", lazy: () => import("@/layouts/LoginLayout") },
	{
		path: "/zahtjevi",
		lazy: () => import("@/layouts/PublicRequestLayout"),
		children: [{ path: ":requestId?", lazy: () => import("@/pages/PublicRequestPage") }]
	},
	{
		path: "/preuzmi-priloge/:downloadLinkId",
		lazy: () => import("@/pages/PublicDownloadEmailAttachmentsPage")
	},
];

export default publicRoutes;